module.exports = __webpack_public_path__ + "img/db154e3.jpg";